var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    fill: "#000"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 60,
    fontFamily: "poppins",
    fontSize: 54,
    fill: "#FFFFFF"
  }, "P")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlogo);
export default __webpack_public_path__ + "static/media/Plogo.7eb9cde782e14056e9674187e89c12f5.svg";
export { ForwardRef as ReactComponent };